import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import asyncComponent from "helpers/asyncComponent";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const mapUserToProps = state => {
	return {
		user: state.auth.user
	};
}

const AuthenticatedRoute = connect(mapUserToProps)(({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
		return (
			rest.user ? (
				<Component {...props} />
			) : (
				<Redirect to={{
					pathname: '/login',
					state: { from: props.location }
				}}/>
			)
		);
	}} />
));

const AnonymousRoute = connect(mapUserToProps)(({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
		return (
			!rest.user ? (
				<Component {...props} />
			) : (
				<Redirect to={{
					pathname: '/',
					state: { from: props.location }
				}}/>
			)
		);
	}} />
));


const Routes =  (props) => {
	const { initialized } = props;

	return (
		initialized ? 
			<Switch>
				<Route exact path="/" component={asyncComponent(() => import('containers/Home/Home'))} />
				<AnonymousRoute exact path="/login" component={asyncComponent(() => import('containers/Login/Login'))} />
				<AnonymousRoute path="/signup" component={asyncComponent(() => import('containers/Signup/Signup'))} />
				<AnonymousRoute path="/login/quickbooks" component={asyncComponent(() => import('containers/Login/LoginQuickbooks'))} />
				<AnonymousRoute path="/password/forgot" component={asyncComponent(() => import('containers/Password/PasswordForgot'))} />
				<AnonymousRoute path="/password/reset/:hashid" component={asyncComponent(() => import('containers/Password/PasswordReset'))} />
				<AnonymousRoute path="/forgot_password/:hashid" component={asyncComponent(() => import('containers/Password/PasswordReset'))} />
				<AnonymousRoute path="/activate/:hashid" exact component={asyncComponent(() => import('containers/Activation/Activation'))}  />
                <Route exact path="/application/signup" component={asyncComponent(() => import('containers/Home/Home'))} />
				<Route path="/initial-application" component={asyncComponent(() => import('containers/InitialApplication/InitialApplication'))} />
				<AuthenticatedRoute path="/application" component={asyncComponent(() => import('containers/Application/Application'))} />
				<AuthenticatedRoute exact path="/logout" component={asyncComponent(() => import('containers/Logout/Logout'))} />
				<Route path="*" render={() => <Redirect to="/" />} />
			</Switch>
		: 
			null
	);
}

const mapStateToProps = state => ({
    initialized: state.app.initialized
});

export default withRouter(connect(mapStateToProps)(Routes));


// WEBPACK FOOTER //
// ./src/routes/index.js